import {
  ISolutionArticle,
  ISolutionCategoryAndFolderStructure,
  ISolutionCategoryStructure,
  ISolutionFolderStructure,
} from "@iloq/shared";

export function getCategoryName(
  structure: ISolutionCategoryAndFolderStructure,
  categoryId: number,
  defaultName = "(category name missing)"
): string {
  const category = structure
    ? structure.categories.find((c: ISolutionCategoryStructure) => c.id === categoryId)
    : undefined;
  return category ? category.name : defaultName;
}

export function getFolderName(
  structure: ISolutionCategoryAndFolderStructure,
  folderId: number,
  defaultName = "(folder name missing)"
): string {
  let folder: ISolutionFolderStructure | undefined;
  if (structure) {
    structure.categories.find((c: ISolutionCategoryStructure) => {
      folder = c.folders.find((f: ISolutionFolderStructure) => f.id === folderId);
      return folder !== undefined;
    });
  }
  return folder ? folder.name : defaultName;
}

export function isVideo(article: ISolutionArticle) {
  return (
    article.descriptionHtml.indexOf("iframe") >= 0 && article.descriptionHtml.indexOf("vimeo") >= 0
  );
}

export function getIconNameByType(article: ISolutionArticle) {
  return isVideo(article) ? "support_video" : "support_doc";
}

/**
 * - Folder & article listings of concealed categories must not be accessible.
 * - Breadcrumb should not contain links to folder & article listings under concealed categories.
 */
export function isConcealedCategory(categoryId: number | null | undefined): boolean {
  return (
    [
      80000455489, // iLOQ 5 Series manual
      80000456122, // iLOQ S50 manual
      80000455549, // iLOQ S10 manual
    ].indexOf(categoryId || -1) >= 0
  );
}
